import {fetcher} from "@framework/fetcher";

const getDiscountCoupon = async (code: string) => {
    return await fetcher({
        url: `/discount-coupons/valide?code=${code}`,
    });
}
export default getDiscountCoupon
